// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        description: "",
        webUrl: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.description !== undefined)
        result.description = tsValueToJsonValueFns.string(value.description);
    if (value.webUrl !== undefined)
        result.webUrl = tsValueToJsonValueFns.string(value.webUrl);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.description !== undefined)
        result.description = jsonValueToTsValueFns.string(value.description);
    if (value.webUrl !== undefined)
        result.webUrl = jsonValueToTsValueFns.string(value.webUrl);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.description !== undefined) {
        const tsValue = value.description;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.webUrl !== undefined) {
        const tsValue = value.webUrl;
        result.push([2, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.description = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.webUrl = value;
    }
    return result;
}
